module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av377-748e7d1a85e4df0d8a9bf1b2418a8453.jpg";